import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import EmbededEntityInput from '../input/embedded_entity'
import moment from 'moment'
import OptionSelect from 'bstrap-react-mobx-admin/new_src/input/option_select'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../input/select'

const TestingTiers = ({ store, label, disabledEntityFromBatch, ...rest }) => {
  const labelAttr = val => {
    const platform = store.options.has('FlyPrivatePlatforms') &&
      store.options.get('FlyPrivatePlatforms').find((i) => i.value === val.platform)
    const tier = store.options.has('PricingTiers') &&
      store.options.get('PricingTiers').find((i) => i.value === val.tier).text
    const typeSale = store.options.has('VodSaleTypes') &&
      store.options.get('VodSaleTypes').find((i) => i.value === val.type_sale).text
    return `#${val.id} | ${(platform && platform.text) || val.platform} | ` +
      `${(tier && tier.text) || val.tier} | ${(typeSale && typeSale.text) || val.type_sale} | ` +
      `${val.period_length} ${val.period_time_unit} | ${val.regions} | ${val.currency_cd} | ` +
      `${moment(val.valid_from).format(defaultConst.DATE_FORMAT)} | ${moment(val.valid_to).format(defaultConst.DATE_FORMAT)}`
  }

  const testingTiersForm = observer(({ state, record, updateFormField, errors }) => {
    const getTier = record.has('tier_id') && record.get('tier_id')
    const getPlatform = state.platformFilter ||
      (getTier && store.options.get('flyprivate_pricings').find(i => i.id === getTier).platform) ||
      localStorage.getItem('platformFilter') ||
      (store.options.has('FlyPrivatePlatforms') && store.options.get('FlyPrivatePlatforms')[0].value)
    const typeSaleOnly = 'svod'
    const svodTiersOnly = val => ((val === Object(val) &&
      'type_sale' in val && val.type_sale.toLowerCase() !== typeSaleOnly)) || !(val.platform === getPlatform) ||
      moment(val.valid_to).isSameOrBefore(moment())

    return (
      <div className='row'>
        <div className='col-sm-12'>
          <OptionSelect
            attr='platformFilter' label={store.__('platform')}
            value={getPlatform}
            onChange={store.updateStorageField(store, state, 'tier_id')}
            options={store.options.get('FlyPrivatePlatforms')}
            labelattr='text' errors={errors} />
          <SelectInput
            attr={'tier_id'}
            label={store.__('tier')}
            labelattr={labelAttr}
            onChange={updateFormField}
            optionsattr={'flyprivate_pricings'}
            optionsrecord={store.options}
            record={record}
            valueFilterFc={svodTiersOnly}
            valueattr='id'
            errors={errors} />
        </div>
      </div>
    )
  })

  const attr = 'flyprivate_testing_tiers'
  return (
    <EmbededEntityInput {...rest}
      disabled={!!disabledEntityFromBatch}
      attr={attr}
      store={store}
      items={store.cv.record.get(attr)}
      label={label || store.__('Add subscription plans')}
      add_title={store.__('Add item')}
      edit_title={store.__('Edit item')}
      errors={store.cv.errors}
      fields={[
        (attr, row) => (<OptionsField
          attr={attr}
          val={row[attr]}
          options={store.options.get('flyprivate_pricings')}
          labelattr={labelAttr}
          valueattr='id' />)
      ]}
      rowId={() => null}
      EditForm={testingTiersForm}
    />
  )
}
export default TestingTiers
